module.exports = __webpack_public_path__ + "media/images/new_landing/logos/marianne-707eebe19ba5bc7a19251e0e93adc418.png";